import { api } from "@/lib/api";

// Items skipped "for now" go to the back of the line, in the order they were skipped (kept for this browser tab).
const KEY = (b) => `snaplist.batchSkip.${b}`;
const skipped = (b) => { try { return JSON.parse(sessionStorage.getItem(KEY(b)) || "[]"); } catch { return []; } };
export const skipForNow = (b, id) => sessionStorage.setItem(KEY(b), JSON.stringify([...skipped(b).filter((x) => x !== id), id]));

export const leftToPost = (items, exclude = []) => items.filter((i) => i.status === "done" && i.draft_exists && !i.posted && !i.listed && !exclude.includes(i.draft_id));

export const nextInBatch = async (batchId, exclude) => {
  const { data } = await api.get(`/photo-batches/${batchId}`);
  const back = skipped(batchId);
  const rank = (i) => (back.includes(i.draft_id) ? 1 + back.indexOf(i.draft_id) : 0);
  return leftToPost(data.items, exclude).sort((a, b) => rank(a) - rank(b))[0] || null;
};
